import { Box, Container, Grid, Typography, Button } from "@mui/material"
import { motion } from "motion/react"

function AboutUs() {
    return (
        <>
            <Box sx={{
                width: "100%",
                p: 3,
                minHeight: "80vh",
                alignContent: "center",
                alignItems: "center",
            }}>
                <Container maxWidth="lg" sx={{
                    p: 3,
                }}>
                    <Grid container spacing={2} display={"flex"} justifyContent={"space-between"}>
                        <Grid component={motion.div} initial={{ opacity: 0, transform: "translateX(-100px)" }} viewport={{ once: true }} whileInView={{ opacity: 1, transform: "translateX(0px)", transition: { delay: 1 } }} item lg={4} sx={{
                            backgroundImage: "url(/aboutus.jpg)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            minHeight: "35rem",
                            display: { xs: "none", sm: "none", lg: "block" },
                            borderRadius: 2
                        }} >
                        </Grid>
                        <Grid item xs={12} sm={12} md={7} component={motion.div} initial={{ opacity: 0, transform: "translateX(100px)" }} viewport={{ once: true }} whileInView={{ opacity: 1, transform: "translateX(0px)", transition: { delay: 0.5 } }}>
                            <Typography variant='body1' color={"secondary"} gutterBottom sx={{
                                opacity: 0.8
                            }} mb={2}>Potřebujete přestěhovat a hledáte spolehlivou stěhovací firmu? Jsme tu pro vás!</Typography>
                            <Typography variant="h3" mb={2} color={"primary"}>
                                Stěhování <Box component={"span"} color={"secondary.main"}>bez starostí</Box>
                            </Typography>
                            <Typography variant="body1" paragraph gutterBottom>
                                Nabízíme komplexní stěhovací služby pro byty, domy, kanceláře dále nabízíme vyklizení nemovitostí, pozůstalostí, sklepů, půd i garáží. Naše zkušené týmy zajistí hladký průběh stěhování, od balení osobních věcí až po montáž nábytku v novém domě.
                            </Typography>


                            <Typography variant="body1" fontWeight={600} paragraph gutterBottom>
                                Proč si vybrat právě nás?
                            </Typography>
                            <Box sx={{ ml: 1, p: 0 }}>
                                <Typography variant="body1" sx={{ m: 1, p: 0 }} paragraph gutterBottom>
                                    •	<span style={{ fontWeight: 500 }}>Rychlost a spolehlivost:</span> Dodržíme dohodnutý termín a vše proběhne rychle a efektivně
                                </Typography>
                                <Typography variant="body1" sx={{ m: 1, p: 0 }} paragraph gutterBottom>
                                    •	<span style={{ fontWeight: 500 }}> Profesionální přístup:</span> Naši stěhováci jsou vyškolení a mají bohaté zkušenosti
                                </Typography>
                                <Typography variant="body1" sx={{ m: 1, p: 0 }} paragraph gutterBottom>
                                    •	<span style={{ fontWeight: 500 }}> Komplexní služby:</span> Nabízíme komplexní servis včetně demontáže nábytku a pojištění majetku
                                </Typography>
                                <Typography variant="body1" sx={{ m: 1, p: 0 }} paragraph gutterBottom>
                                    •	<span style={{ fontWeight: 500 }}> Přijatelné ceny:</span> Vypracujeme vám individuální cenovou nabídku
                                </Typography>
                            </Box>

                            <Button variant="contained" color="secondary" fullWidth sx={{}}>
                                Více
                            </Button>
                        </Grid >
                    </Grid >
                </Container >
            </Box >
        </>
    )
}

export default AboutUs